import React from "react";
import Image from "next/image";
import Remote from "../LoaderRemote";
import { useTranslation } from "../../context/TranslationContext";

const ReviewItem = ({ data, isReview, className }) => {
  const { excellent } = useTranslation();
  return (
    <div className={"flex gap-x-10 px-[1.3rem] lg:px-0 " + className}>
      <div className="lg:w-64 xl:w-360 bg-red-50 relative hidden lg:block">
        <div className="relative w-full h-60">
          <Image
            src={data.resim}
            layout="fill"
            loader={Remote}
            alt={data.title}
          />
        </div>
        <div className="absolute bottom-0 left-0 z-10 bg-review-img-gra w-full h-24 pl-9 pt-12">
          <span className="text-white text-base font-bold">{data.baslik}</span>
        </div>
      </div>
      <div className="flex flex-col flex-1">
        <div
          className={
            isReview
              ? "flex lg:justify-between "
              : "flex lg:justify-between lg:mt-0"
          }
        >
          <div
            className={
              isReview
                ? "h-36 lg:h-28 w-full lg:hidden"
                : "h-28 w-32 mm:w-44 lg:hidden"
            }
          >
            <div className="relative w-full h-full">
              <Image
                src={data.resim}
                layout="fill"
                loader={Remote}
                objectFit={"cover"}
                alt={data.title}
              />
            </div>
          </div>
          <div className="flex-col text-brand-black hidden lg:flex">
            <span className="font-bold text-base  leading-6">{data.isim}</span>
            <span className="text-xs opacity-50 -mt-0.5">{data.tarih}</span>
          </div>
          {isReview != true && (
            <div className="flex flex-col lg:items-end justify-center pl-4 lg:pl-0 lg:hidden">
              <span className="text-brand-black text-xl mm:text-2xl font-bold lg:hidden">
                {data.baslik}
              </span>
              {/*
                <span className="text-primary lg:text-orange font-bold text-lg leading-4 mt-1 lg:mt-0">
                  1950₺ - 5200₺
                </span>
              */}
              <span className="text-brand-gray-9 lg:text-brand-black font-bold text-13 mr-1 mt-0.5 lg:mt-0">
                {data.bolge}
              </span>
            </div>
          )}
        </div>
        <p
          className={
            "mt-4 text-brand-black opacity-50 text-sm order-3 lg:order-none " +
            (!isReview ? "max-h-16 overflow-hidden lg:max-h-max" : "")
          }
        >
          {data.mesaj}
        </p>
        <div className="mt-3.5 lg:mt-auto flex items-center order-2 lg:order-none justify-between">
          <div className="text-brand-black lg:hidden flex flex-col">
            <span className="font-bold text-base  leading-6">{data.isim}</span>
            <span className="text-xs opacity-50 -mt-0.5">{data.tarih}</span>
          </div>
          <div className="flex flex-col items-start">
            <span className="text-black lg:text-primary font-bold text-4xl">
              {data.puan} <small className="text-15 -ml-1.5">/5</small>
            </span>
            <span className="text-brand-black font-bold text-xxs -mt-2.5">
              {excellent}
              <span className="flex float- right text-primary fill-primary stroke-primary mt-0.5 ml-1">
                {Array.from(Array(parseInt(data.puan)).keys()).map((e, i) => (
                  <Image
                    src={"/icons/FaStarPrimary.svg"}
                    key={i}
                    width={10}
                    height={10}
                    alt={"Star Icon"}
                    layout={"fixed"}
                  />
                ))}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewItem;
